import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import TextareaAutosize from "react-textarea-autosize";
import "../styles/components/form.css";
import "../styles/components/promotion_form.css";
import CloseIcon from "../assets/icons/close-icon.svg";
import RequirementItem from "../components/RequirementItem";
import RequirementForm from "../components/RequirementForm";
import { createVacancy, updateVacancy } from "../services/vacanciesService";
import Loader from "../components/Loader";

const VacancyForm = ({ onClose, initialData, mode, onSuccess }) => {
    const [title, setTitle] = useState(initialData?.title || "");
    const [description, setDescription] = useState(initialData?.description || "");
    const [requirements, setRequirements] = useState(initialData?.points || []);
    const [showRequirementForm, setShowRequirementForm] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSaveRequirement = (requirementText) => {
        setRequirements([...requirements, requirementText]);
        setShowRequirementForm(false);
    };

    const handleDeleteRequirement = (index) => {
        setRequirements(requirements.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const vacancyData = {
                title,
                description,
                points: requirements
            };

            if (mode === "create") {
                await createVacancy(vacancyData);
                toast.success("Вакансия успешно создана", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            } else {
                await updateVacancy(initialData.id, vacancyData);
                toast.success("Изменения сохранены", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            }

            onSuccess?.();
            onClose();
        } catch (error) {
            console.error("Ошибка сохранения:", error);
            toast.error("Ошибка при сохранении вакансии", {
                position: "bottom-left",
                autoClose: 3000
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const isFormValid =
        title.trim() !== "" &&
        description.trim() !== "" &&
        requirements.length > 0;

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <div className="modal-overlay">
            <div className="form">
                <div className="form-header">
                    <h1 className="form-title">
                        {mode === "edit" ? "Редактирование вакансии" : "Создание вакансии"}
                    </h1>
                    <button className="close-button" onClick={onClose}>
                        <img src={CloseIcon} alt="Закрыть" />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <h2 className="form-section-title">Основная информация</h2>

                    <div className="form-group">
                        <label className="field-label">Заголовок вакансии</label>
                        <TextareaAutosize
                            className="textarea-input"
                            placeholder="Введите заголовок вакансии"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="field-label">Описание вакансии</label>
                        <TextareaAutosize
                            className="textarea-input description"
                            placeholder="Введите описание вакансии"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                        />
                    </div>

                    <h2 className="form-section-title">Список требований</h2>
                    <div className="form-items-container">
                        {requirements.length > 0 ? (
                            requirements.map((requirement, index) => (
                                <RequirementItem
                                    key={index}
                                    requirement={requirement}
                                    index={index + 1}
                                    onDelete={() => handleDeleteRequirement(index)}
                                />
                            ))
                        ) : (
                            <span className="empty-list-label">Требования отсутствуют</span>
                        )}
                        <button
                            type="button"
                            className="add-to-list-button"
                            onClick={() => setShowRequirementForm(true)}
                        >
                            + Добавить требование
                        </button>
                    </div>

                    <div className="form-buttons">
                        <button type="button" className="cancel-button" onClick={onClose}>
                            Отменить
                        </button>
                        <button
                            type="submit"
                            className="save-button"
                            disabled={!isFormValid || isSubmitting}
                        >
                            Сохранить
                        </button>
                    </div>
                </form>

                {isSubmitting && (
                    <div className="loader-overlay">
                        <Loader />
                        <p>Сохранение вакансии...</p>
                    </div>
                )}
            </div>

            {showRequirementForm && (
                <RequirementForm
                    onClose={() => setShowRequirementForm(false)}
                    onSave={handleSaveRequirement}
                />
            )}
        </div>
    );
};

export default VacancyForm;
